import React from 'react'
import { PhoneDisclaimer } from '../Footer/PhoneDisclaimer'
import { Box } from '@mui/material'

export const PhoneDisclaimerContainer: React.FC = () => {
  return (
    <Box
      sx={{
        mt: 4,
        pl: 5,
        pr: 5
      }}
    >
      <PhoneDisclaimer />
    </Box>
  )
}
